import { render } from "./BrandPortfolioSellerNameCell.vue?vue&type=template&id=1489956d&scoped=true"
import script from "./BrandPortfolioSellerNameCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioSellerNameCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioSellerNameCell.vue?vue&type=style&index=0&id=1489956d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1489956d"]])

export default __exports__